import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import Measure from 'react-measure';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import { PostTemplateItem, Popover, WatchClickOutside } from 'components';
import { LLSocialAccountChip } from 'components/FormElements';
import { HorizontalNav } from 'containers';
import * as styles from '../ContentChannelRow/ContentChannelRow.scss';
import StarPopover from './StarPopover.jsx';
import { connect } from 'react-redux';
import { deleteAccountFromTag, enqueuePost, subscribeAccountsToTag } from 'redux/modules/contentLibrary';

var VisibilitySensor = require('react-visibility-sensor');

var ContentChannelRow = (_dec = connect(function (state) {
  return {
    config: state.config,
    theme: state.theme,
    organization: state.organization.current,
    categoriesContent: state.contentLibrary.categoriesContent,
    addingSAInProgress: state.contentLibrary.addingSAInProgress,
    unfavoriting: state.contentLibrary.unfavoriting
  };
}, {
  deleteAccountFromTag: deleteAccountFromTag,
  enqueuePost: enqueuePost,
  subscribeAccountsToTag: subscribeAccountsToTag
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ContentChannelRow, _Component);

  var _super = _createSuper(ContentChannelRow);

  function ContentChannelRow(props) {
    var _this;

    _classCallCheck(this, ContentChannelRow);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "incrementPage", function () {
      _this.removePopover();

      _this.setState({
        offsetIndex: _this.state.offsetIndex + 1 < _this.state.maxOffsetIndex ? _this.state.offsetIndex + 1 : _this.state.offsetIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "decrementPage", function () {
      _this.removePopover();

      _this.setState({
        offsetIndex: _this.state.offsetIndex - 1 > 0 ? _this.state.offsetIndex - 1 : 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setPopover", function (postTemplateItem) {
      if (_this.props.setPopover) {
        return _this.props.setPopover(postTemplateItem);
      }

      if (_this.state.currentPopover) {
        _this.state.currentPopover.hide();
      }

      _this.setState({
        currentPopover: postTemplateItem
      });
    });

    _defineProperty(_assertThisInitialized(_this), "deleteSocialAccountFromChannel", function (sa, deleteAll) {
      var index = -1;

      if (_this.props.favorite && _this.props.favorite.social_accounts) {
        for (var i = 0; i < _this.props.favorite.social_accounts.length; i++) {
          var a = _this.props.favorite.social_accounts[i];

          if (a.id === sa.id) {
            index = i;
            break;
          }
        }
      }

      if (index > -1) {
        _this.props.favorite.social_accounts.splice(index, 1);
      }

      _this.props.deleteAccountFromTag(_this.props.organization.id, [sa.id], _this.props.category.tagId).then(function () {
        _this.setState({
          openDialogSocialAccountId: null
        });

        window.location.reload();
      })["catch"](function (err) {
        console.error(err);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removePopover", function () {
      if (_this.props.removePopover) {
        return _this.props.removePopover();
      }

      if (_this.state.currentPopover) {
        _this.state.currentPopover.hide();
      }

      _this.setState({
        currentPopover: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addPostToQueue", function (queue, postData) {
      _this.props.enqueuePost(_this.props.organization.id, postData, queue).then(function () {
        return _this.props.reloadQueues();
      })["catch"](function (err) {
        console.error(err);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleLeftClick", function () {
      _this.setState({
        left: _this.state.left + _this.state.width
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRightClick", function () {
      _this.setState({
        left: _this.state.left - _this.state.width
      });

      if (!_this.props.categoriesContent[_this.props.category.tagId].allContentLoaded) {
        _this.setState({
          innerWrapWidth: _this.state.innerWrapWidth + _this.state.numItemsVisible * 170
        });
        /* this.props.getCategoryContent(
          this.props.category.tagId,
          this.props.categoriesContent[this.props.category.tagId].offset + 10,
          this.state.numItemsVisible
        );*/

      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleAccountStateInPopover", function (sa) {
      var copy = [].concat(_this.state.addOverlaySelectedAccounts);

      if (copy.indexOf(sa.id) !== -1) {
        copy.splice(copy.indexOf(sa.id), 1);
      } else {
        copy.push(sa.id);
      }

      _this.setState({
        addOverlaySelectedAccounts: copy
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submitSocialAccountSubscriptions", function () {
      _this.props.subscribeAccountsToTag(_this.props.organization.id, _this.state.addOverlaySelectedAccounts, _this.props.category.tagId).then(function () {
        _this.setState({
          addOverlaySelectedAccounts: [],
          showAddAccountDialog: false
        });

        _this.props.reloadQueues();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getContentTimeout", null);

    _defineProperty(_assertThisInitialized(_this), "handleVisibilityChange", function (isVisible) {
      _this.setState({
        isVisibleVertically: isVisible
      });

      if (isVisible) {
        _this.getContentTimeout = setTimeout(function () {
          // only make the call the first time row is visible
          if (!_this.props.categoriesContent[_this.props.category.tagId].hasOwnProperty('content')) {//  this.props.getCategoryContent(this.props.category.tagId, 0, this.state.numItemsVisible);
          }
        }, 300);
      } else {
        clearTimeout(_this.getContentTimeout);
      } //

    });

    _defineProperty(_assertThisInitialized(_this), "renderAddAccountDialog", function () {
      var unsubscribedSocialAccounts = [];

      _this.props.organization.SocialAccounts.forEach(function (sa) {
        var isSubed = false;

        _this.props.favorite.social_accounts.forEach(function (subSa) {
          if (subSa.id === sa.id) {
            isSubed = true;
          }
        });

        if (!isSubed && sa.platform.indexOf('Instagram') !== 0 && sa.platform !== 'Facebook profile') {
          unsubscribedSocialAccounts.push(sa);
        }
      });

      var unselectedSocialAccountChips = unsubscribedSocialAccounts.map(function (sa) {
        var opacity = _this.state.addOverlaySelectedAccounts.indexOf(sa.id) !== -1 ? 1 : 0.5;
        return /*#__PURE__*/React.createElement(LLSocialAccountChip, {
          key: sa.id,
          socialAccount: sa,
          style: {
            "float": 'left',
            margin: '3px',
            opacity: opacity,
            cursor: 'pointer'
          },
          onClick: _this.toggleAccountStateInPopover.bind(_assertThisInitialized(_this), sa)
        });
      });
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        style: {
          color: _this.props.theme.colors.gray1
        }
      }, unsubscribedSocialAccounts.length > 0 ? "Pick a social account from the list below to add ".concat(_this.props.category.tagName, " content to that queue.") : 'This Content Category is connected to all of your available Queues.'), unsubscribedSocialAccounts.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, unselectedSocialAccountChips)));
    });

    _this.state = {
      offsetIndex: 0,
      offsetAmount: 500,
      maxOffsetIndex: 0,
      currentPopover: null,
      addOverlaySelectedAccounts: [],
      openDialogSocialAccountId: null,
      isVisibleVertically: false,
      left: 0,
      width: 100,
      showAddAccountDialog: false,
      innerWrapWidth: 5000,
      removingInProgress: false,
      numItemsVisible: 10
    };
    return _this;
  }

  _createClass(ContentChannelRow, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.setState({
        innerWrapWidth: window.innerWidth
      });
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.isFavoriteRow && !this.props.isFavoriteRow) {
        this.setState({
          isVisibleVertically: true
        });

        if (!nextProps.categoriesContent[nextProps.category.tagId].hasOwnProperty('content')) {// this.props.getCategoryContent(nextProps.category.tagId, 0, this.state.numItemsVisible);
        }
      }
    }
    /** *******************************************************************************************
    CUSTOM METHODS
    ********************************************************************************************/

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var content = this.props.categoriesContent[this.props.category.tagId].content ? this.props.categoriesContent[this.props.category.tagId].content : null; //
      // first part checks if we have scrolled beyond the last item of content
      // second part below (after ||) is checking for rows that have less content than the width of screen
      //

      var atEnd = this.state.innerWrapWidth + this.state.left < this.state.width && this.props.categoriesContent[this.props.category.tagId].allContentLoaded || this.props.categoriesContent[this.props.category.tagId].allContentLoaded && this.props.categoriesContent[this.props.category.tagId].content.length * 170 < this.state.width;
      var templateItems = content ? content.map(function (c, idx) {
        return /*#__PURE__*/React.createElement(PostTemplateItem, {
          data: c,
          key: c.id,
          setPopover: _this2.setPopover,
          removePopover: _this2.removePopover,
          user: _this2.props.user,
          org: _this2.props.organization,
          onShouldQueuePost: _this2.addPostToQueue,
          isVisible: //              (idx + 1) * 160 >= this.state.left &&
          //             (idx + 1) * 160 <= this.state.width + 200 + Math.abs(this.state.left) &&
          _this2.state.isVisibleVertically
        });
      }) : null;
      var offsetStyle = {
        left: -this.state.offsetAmount * this.state.offsetIndex
      };
      var subscribedArray = this.props.favorite && this.props.favorite.social_accounts && this.props.favorite.social_accounts.length > 0 ? _toConsumableArray(this.props.favorite.social_accounts) : this.props.category.queuesConnected && this.props.category.queuesConnected.length > 0 ? _toConsumableArray(this.props.category.queuesConnected) : null;
      var subscribedChips = subscribedArray && subscribedArray.length > 0 ? subscribedArray.map(function (sa) {
        var dialogButtons = [/*#__PURE__*/React.createElement(RaisedButton, {
          label: "Cancel",
          onClick: function onClick() {
            return _this2.setState({
              openDialogSocialAccountId: null
            });
          },
          key: "".concat(sa.id, "_0"),
          style: {
            margin: 8,
            marginTop: 24
          },
          disabled: _this2.props.unfavoriting
        }), /*#__PURE__*/React.createElement(RaisedButton, {
          secondary: true,
          disabled: _this2.props.unfavoriting,
          label: "Remove",
          onClick: _this2.deleteSocialAccountFromChannel.bind(_this2, sa, true),
          key: "".concat(sa.id, "_1"),
          style: {
            margin: 8,
            marginTop: 24
          }
        })];
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LLSocialAccountChip, {
          style: {
            "float": 'left',
            marginRight: '12px',
            marginTop: '12px'
          },
          socialAccount: sa,
          requestDelete: function requestDelete() {
            return _this2.setState({
              openDialogSocialAccountId: sa.id
            });
          },
          key: sa.id
        }), /*#__PURE__*/React.createElement(Dialog, {
          actions: dialogButtons,
          open: _this2.state.openDialogSocialAccountId === sa.id,
          title: "Remove All ".concat(_this2.props.category.tagName, " Content?")
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
          style: {
            color: _this2.props.theme.colors.gray1
          }
        }, "This will remove ".concat(_this2.props.category.tagName, " content from your ").concat(sa.username, " queue and also\n                      suspend the addition of new pieces of content.")), /*#__PURE__*/React.createElement("p", {
          style: {
            color: _this2.props.theme.colors.gray1
          }
        }, "You can still select individual pieces of content from the ", _this2.props.category.tagName, " content library and schedule it."))));
      }) : null;
      var unsubscribedSocialAccounts = [];

      if (this.props.organization.SocialAccounts && this.props.favorite && this.props.favorite.social_accounts) {
        this.props.organization.SocialAccounts.forEach(function (sa) {
          var isSubed = false;

          _this2.props.favorite.social_accounts.forEach(function (subSa) {
            if (subSa.id === sa.id) {
              isSubed = true;
            }
          });

          if (!isSubed) {
            unsubscribedSocialAccounts.push(sa);
          }
        });
      }

      var hasSocialAccount = false;

      if (this.props.organization.SocialAccounts) {
        if (this.props.organization.SocialAccounts.length) {
          hasSocialAccount = true;
        }
      }

      var addAccountActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: function onClick() {
          return _this2.setState({
            showAddAccountDialog: false
          });
        },
        style: {
          marginRight: 24
        },
        disabled: this.props.addingSAInProgress
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: this.props.addingSAInProgress ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-spin fa-spinner",
          style: {
            fontSize: 20
          }
        }) : 'Add',
        onClick: this.submitSocialAccountSubscriptions,
        disabled: this.props.addingSAInProgress || !this.state.addOverlaySelectedAccounts || this.state.addOverlaySelectedAccounts.length === 0
      })];
      return /*#__PURE__*/React.createElement("div", {
        style: _objectSpread(_objectSpread({}, this.props.style), {}, {
          "float": 'left',
          width: '100%'
        })
      }, /*#__PURE__*/React.createElement(VisibilitySensor, {
        partialVisibility: true,
        onChange: this.handleVisibilityChange,
        scrollCheck: true,
        offset: {
          bottom: -200,
          top: -200
        }
      }, /*#__PURE__*/React.createElement(Measure, {
        whitelist: ['width'],
        onMeasure: function onMeasure(dimensions) {
          _this2.setState({
            width: dimensions.width - 150,
            numItemsVisible: Math.ceil((dimensions.width - 150) / 170) + 1
          });
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.wrap,
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.rowHeaderWrap,
        style: this.state.left !== 0 ? {
          boxShadow: '4px 0 4px -4px rgba(0,0,0,0.5)'
        } : {}
      }, /*#__PURE__*/React.createElement("h1", {
        className: styles.rowHeader
      }, this.props.category.tagName, "\xA0", this.props.config.features.showQueue && this.props.organization && this.props.organization.SocialAccounts && /*#__PURE__*/React.createElement(StarPopover, _defineProperty({
        reloadQueues: this.props.reloadQueues,
        selected: this.props.favorite,
        channelName: this.props.category.tagName,
        socialAccounts: this.props.organization.SocialAccounts,
        subscribeAccountsToTag: this.props.subscribeAccountsToTag,
        tagId: this.props.category.tagId
      }, "reloadQueues", this.props.reloadQueues)))), /*#__PURE__*/React.createElement("div", {
        className: styles.outerWrap,
        style: {
          width: this.state.width
        }
      }, this.state.left !== 0 && /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.control, " ").concat(styles.leftControl),
        onClick: this.handleLeftClick
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-arrow-back"
      })), !atEnd && /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.control, " ").concat(styles.rightControl),
        onClick: this.handleRightClick
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-arrow-forward"
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.innerWrap,
        style: {
          left: this.state.left,
          width: this.state.innerWrapWidth
        }
      }, templateItems, this.props.categoriesContent[this.props.category.tagId].loadingContent && /*#__PURE__*/React.createElement("div", {
        className: styles.loadingContentPlaceholder
      }, /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.spinner, " fa fa-spinner fa-spin")
      })))), (this.props.favorite || subscribedChips && subscribedChips.length > 0) && hasSocialAccount && /*#__PURE__*/React.createElement("div", {
        className: styles.socialChipsWrap
      }, /*#__PURE__*/React.createElement("h4", {
        className: styles.socialChipsHeading
      }, "Queues:"), subscribedChips, unsubscribedSocialAccounts.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: styles.saAddButtonWrap,
        onClick: function onClick() {
          return _this2.setState({
            showAddAccountDialog: true
          });
        },
        style: {
          "float": 'left',
          marginTop: '12px'
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.saAddButtonIcon, " ion-ios-plus icon")
      }))), /*#__PURE__*/React.createElement(Dialog, {
        actions: addAccountActions,
        open: this.state.showAddAccountDialog,
        title: "Add Content To Your Queue"
      }, this.props.favorite && this.props.favorite.social_accounts && this.renderAddAccountDialog())))));
    }
  }]);

  return ContentChannelRow;
}(Component)) || _class);
export { ContentChannelRow as default };